(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-basket/assets/javascripts/status.js') >= 0) return;  svs.modules.push('/components/themes/sport-basket/assets/javascripts/status.js'); "use strict";

(function (svs) {
  svs = svs || {};
  svs.themes = svs.themes || {};
  svs.themes.sport_basket = svs.themes.sport_basket || {};
  var logger = new svs.core.log.Logger('svs.themes.sport_basket');

  svs.themes.sport_basket.matchNotice = function (match) {
    if (!match) {
      logger.warn('Invalid parameter to matchNotice, returning empty string.');
      return '';
    }

    var matchStatus;

    switch (match.status) {
      case 16:
        matchStatus = 'Väntar på förlängning';
        break;

      case 18:
        matchStatus = 'Väntar på straffläggning';
        break;

      case 24:
        matchStatus = 'Försenad matchstart';
        break;

      case 25:
        matchStatus = 'Inställd';
        break;

      case 26:
        matchStatus = 'Avbruten';
        break;

      case 28:
        matchStatus = 'Stoppad av domare';
        break;

      default:
        matchStatus = '';
        break;
    }

    return matchStatus;
  };

  svs.themes.sport_basket.isLive = function (status) {
    if (window.location.href.indexOf('isMocked') > -1) {
      return true;
    }

    return !!_.contains([1, 2, 13, 14, 16, 18, 19, 22, 37, 38, 39, 40], status);
  };

  svs.themes.sport_basket.isFinished = function (status) {
    return !!_.contains([31, 32, 33, 41], status);
  };

  svs.themes.sport_basket.isEnded = function (status) {
    return !!_.contains([25, 26, 28, 31, 32, 33, 41], status);
  }; 


  svs.themes.sport_basket.subscribeMatch = function (params) {
    return svs.themes.isDateHoursDiff(params.time, -4) && !svs.themes.sport_basket.isEnded(params.status);
  };

  svs.themes.sport_basket.hasStarted = function (status) {
    return status > 0 && !_.contains([23, 24, 25], status);
  };


  svs.themes.sport_basket.isFullTimeOrPassed = function (status, options) {
    options = _.extend({
      includeFullTime: true,
      includePauses: true,
      includeFinished: true
    }, options);
    var statusesForOvertimeOrPenalties = [19, 20, 21, 22];

    if (options.includeFullTime) {
      statusesForOvertimeOrPenalties.push(31, 41);
    }

    if (options.includePauses) {
      statusesForOvertimeOrPenalties.push(16, 17, 18);
    }

    if (options.includeFinished) {
      statusesForOvertimeOrPenalties.push(32, 33);
    }

    return _.contains(statusesForOvertimeOrPenalties, status);
  };


  svs.themes.sport_basket.getStatusText = function (options) {
    var text = '';
    options = _.defaults({}, options, {
      statusId: null,
      startTime: null,
      getStartTime: true
    });
    var status = options.statusId;

    if (svs.themes.sport_basket.isLive(status)) {
      if (status === 1) {
        text = 'H1';
      } else if (status === 2) {
        text = 'H2';
      } else if (status === 37) {
        text = 'Q1';
      } else if (status === 38) {
        text = 'Q2';
      } else if (status === 39) {
        text = 'Q3';
      } else if (status === 40) {
        text = 'Q4';
      } else if (_.contains([14, 16, 18], status)) {
        text = 'PAUS';
      } else if (status === 19) {
        text = 'ÖT';
      }

      if (!text) {
        text = 'Q1';
      }
    } else if (svs.themes.sport_basket.isEnded(status)) {
      if (status === 32) {
        text = 'ÖT';
      } else if (status === 33) {
        text = 'STR';
      } else {
        text = 'FT';
      }
    } else if (options.startTime && options.getStartTime) {
      text = svs.themes.formatTime(options.startTime);
    }

    return text;
  };

})(svs);
 })(window);